import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Init_des } from '../../components/Javascript/Init_des'
import init_pic_1 from "../../Images/Initiatives/init2/SHG1.jpg";
import init_pic_2 from "../../Images/Initiatives/init2/SHG2.jpg";
// import init_pic_3 from "../../Images/Initiatives/init2/SHG3.jpg";
// import init_pic_4 from "../../Images/Initiatives/init2/SHG4.jpg";
export const Init2 = props => {
  return (
    <>
      <Init_des
      i1={init_pic_1} i2={init_pic_2}
      title="SHG FORMATION SESSION"
      date=" August 20, 2022"
      village=" Beladi"
        p1="The world's largest untapped talent pool is comprised of women. Team UBA, IITR helped rural women recognize their potential in bringing rural upliftment. The team knows the importance of a strong community network in rural areas and hence always worked to uplift the SHGs, from their formation to smooth functioning."

        p2="The team contacted women of the village Beladi to form a Self Help Group (SHG). With its enthusiastic efforts, the team managed to conduct a session with the help of Mrs. Neeraj Saini, a member of an active SHG. During the session, the women were told about the importance and responsibilities of being a part of an SHG. Also, the women showed great interest in working as a group and achieving financial independence. The documentation process of SHG members was carried out smoothly with the team and Mrs. Neeraj Saini."

        p3="So the team successfully formed SHG in the village with the support of passionate members. The SHG is currently focusing on some initiatives and attended the Bio-enzyme workshop being conducted by the team."
      />
    </>
  )
}
